import React, { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "./Context/GlobalContext";
import { useAuth } from "./Context/AuthContext";
import { SuspenseLoader } from "./Layout/Common/loader";
import SessionTimeoutProvider from "./Context/sessionTimeoutProvider";
import SuspenseComponentLoader from "./Context/SuspenseLoader";
import { useGlobalFunction } from "./Context/GlobalFunctionContext";
import { debounce } from "lodash";
import { NoPermission } from "./Layout/Common/NoPermission";
import { setLoginReturnUrl } from "./Layout/Common/common";

const ProtectedRoute = ({ Component, restrictBrowseOnly = false }) => {
  const { IsTimeout, setIsTimeout, refreshable, setRefreshable } = useContext(GlobalContext);
  const { refreshSettings } = useGlobalFunction();
  const { postAuthentication, authLoading, role, isBrowseOnly } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    checkAuth({ isRedirect: true });
    return () => {
      cancelled = true;
    };
  }, [Component]);

  const refreshSettingsRef = useRef(refreshSettings);
  useEffect(() => {
    refreshSettingsRef.current = refreshSettings;
  });

  const debouncedRef = useRef(null);
  if (debouncedRef.current === null) {
    debouncedRef.current = debounce(() => {
      if (process.env.REACT_APP_ENV == 1 || true) {
        if (typeof refreshSettingsRef.current === "function") refreshSettingsRef.current();
      }
    }, 2000);
  }

  useEffect(() => {
    const handleVisibility = () => {
      //checkAuth({ isRedirect: false });
      if (document.visibilityState !== "visible") return;
      if (refreshable === true) debouncedRef.current();
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      debouncedRef.current.cancel();
    };
  }, [refreshable]);

  const checkAuth = async ({ isRedirect = false }) => {
    setLoading(true);
    var response = await postAuthentication();
    if (response) {
      setLoading(false);
    } else {
      if (isRedirect) {
        setLoginReturnUrl();
        window.location.replace("/login");
      } else setIsTimeout(true);
    }
  };
  const location = useLocation();
  const page = useMemo(() => (Component ? <Component /> : null), [Component]);

  if (authLoading) {
    return <SuspenseComponentLoader />;
  }

  // Browse-only users are not allowed to reach checkout / order-details pages.
  if (restrictBrowseOnly && isBrowseOnly) {
    return <NoPermission />;
  }

  if (!Component) {
    console.error("ProtectedRoute: Received undefined Component prop for path", location && location.pathname);
    return null;
  }

  return (
    <SessionTimeoutProvider>
      <SuspenseLoader show={loading} />
      <div style={{ visibility: loading ? "hidden" : "" }}>
        {page}
      </div>
    </SessionTimeoutProvider>
  );
};

export default ProtectedRoute;
